angular.module('property')
    .component('propertyList', {
        bindings: {
            statistics: '<',
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/property/list.html',
        controller: function ($scope, $state, $stateParams, $httpParamSerializer, toastr, Project, Property, PropertyService, PropertyImportService, PropertyDealService, $http, Principal) {
            this.reset = () => this.filters = {};
            this.PropertyDealService = PropertyDealService;
            this.PropertyService = PropertyService;
            this.PropertyImportService = PropertyImportService;
            this.canReadPropertyPriceTransparency = Principal.hasAnyAuthority(['ROLE_PROPERTY_PRICE_TRANSPARENCY']);

            this.$onInit = () => {
                this.projectAssetGroups = [
                    {name: 'G1'},
                    {name: 'G2'},
                    {name: 'G3'},
                ];
            }
            this.getExportUrlForProject = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/property-csv/" + $stateParams.project + "/export?" + $httpParamSerializer(paramsAll)
            }
            this.getExportUrlForProjectBGT = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, this.filters);
                angular.extend(paramsAll, params);
                return "/crm/api/property-csv/" + $stateParams.project + "/export-bgt?" + $httpParamSerializer(paramsAll)
            }
            this.getGeneralExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/property-csv/export?" + $httpParamSerializer(paramsAll)
            }
            this.getExportUrlForProjectPriceTransparency = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/property-price-transparency/" + $stateParams.project + "/export?" + $httpParamSerializer(paramsAll)
            }

            $scope.$on('property.updated', () => $state.reload());
        }
    })
